
export const tabsTheme = {
	variants: {
		primary: {
			// Define <Tab> within <Tabs>
			tab: {
				color: "gray.500",
				fontWeight: "semibold",
				_selected: {
					color: "black",
					borderBottom: "2px solid limegreen"
				}
			}
		}
	}
};
